// extracted by mini-css-extract-plugin
export default {"form":"TaskForm_form__LZ0D1","field":"TaskForm_field__3Hftx"};